import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableEventsComponent from '../components/TableEventsComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

class EventsPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole
        }
    }

    async componentDidMount() {
        let role = await validateSession(true);
        this.setState({ checked: true, role: role });
    }

    addEvent = () => {
        navigateTo('/addEvent');
    }

    // Un cumpleaños o un festejo con todo pago: el alta en una sola pantalla.
    addPrivateEvent = () => {
        navigateTo('/addPrivateEvent');
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={33} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                {/* minWidth:0 — el header es un .row de Bootstrap y colapsa contra
                                    los botones (mismo arreglo que en «Editar evento»). */}
                                <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                                    <HeaderComponent title="Cafetería" subtitle="Eventos" />
                                </div>
                                <div className="text-nowrap" style={{ flex: '0 0 auto' }}>
                                    <button type="button" className="btn btn-white" onClick={() => this.addPrivateEvent()}>
                                        + Evento privado
                                    </button>
                                    <button type="button" className="btn btn-accent ml-2" onClick={() => this.addEvent()}>
                                        + Crear evento
                                    </button>
                                </div>
                            </div>
                            <TableEventsComponent />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default EventsPage;
